import React, { useEffect, useState, Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/Header.css";
import "../styles/MenuFooter.css";
import GenericService from "../services/Generic.service";
import { createKey } from "../utils/KeysUtil";

const MenuFooter = (props) => {
  const [documents, setDocuments] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (props.portalid != null && !loading) {
      if (props.portalid > 0) {
        setLoading(true);
        loadMenus();
      }
    }
  }, [props.portalid]);

  const loadMenus = async () => {
    await GenericService.getOne("portais", props.portalid)
      .then(async (docs) => {
        if (docs) {
          setDocuments(docs);
        }
      })
      .catch((err) => {
        //console.log(err);
      });
  };

  return (
    <div className="MenuFooterSection">
      {documents && documents.menus && (
        <>
          {documents.menus.map((doc, indxDoc) => (
            <Fragment key={indxDoc}>
              {doc.menus !== undefined ? (
                <>
                  <div className="pMenuFooter">
                    <ul className="list-group ulItemsNoBullets">
                      <div className="linkMenuHeaderFooter">{doc.title}</div>
                      {doc.menus.map((menu, indxMenu) => (
                        (menu.metadados.active === undefined || menu.metadados.active === true) && (
                          <Fragment key={createKey()}>
                            {menu.title !== "-" && (
                              <Fragment key={indxMenu}>
                                <li>
                                  <a className="linkMenuItemFooter" href={menu.url}>
                                    {menu.title}
                                  </a>
                                </li>
                              </Fragment>
                            )}
                          </Fragment>
                        )
                      ))}
                    </ul>
                  </div>
                </>
              ) : (
                <div className="pMenuFooter">
                  <a className="linkMenuHeaderFooter" href={doc.url}>
                    {doc.title}
                  </a>
                </div>
              )}
            </Fragment>
          ))}
          <div className="pMenuFooter">
            <ul className="list-group ulItemsNoBullets">
              <div className="linkMenuHeaderFooter">Apoio</div>
              <li>
                <a className="linkMenuItemFooter" href={"http://cbtkd.org.br/eventos/evento/pesagem?id?id=FwyoBkrKC6vlDKDXqUfN"}>
                  {"Pesagem"}
                </a>
              </li>
              <li>
                <a className="linkMenuItemFooter" href={"http://cbtkd.org.br/eventos/sumulas?id=FwyoBkrKC6vlDKDXqUfN"}>
                  {"Sumulas"}
                </a>
              </li>
            </ul>
          </div>

        </>
      )
      }
    </div >
  );
};

export default MenuFooter;
